// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserAddGroup_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 8C12.433 8 14 6.433 14 4.5 14 2.567 12.433 1 10.5 1 8.567 1 7 2.567 7 4.5 7 6.433 8.567 8 10.5 8ZM10.5 6C11.3284 6 12 5.32843 12 4.5 12 3.67157 11.3284 3 10.5 3 9.67157 3 9 3.67157 9 4.5 9 5.32843 9.67157 6 10.5 6ZM4 10C5.65685 10 7 8.65685 7 7 7 5.34315 5.65685 4 4 4 2.34315 4 1 5.34315 1 7 1 8.65685 2.34315 10 4 10ZM4 8C4.55228 8 5 7.55228 5 7 5 6.44772 4.55228 6 4 6 3.44772 6 3 6.44772 3 7 3 7.55228 3.44772 8 4 8Z" class="svg-bg"/>
  <path d="M5.12172 13.3439C5.04197 13.7167 5 14.1035 5 14.5V15H7V14.5C7 12.7368 8.30385 11.2781 10 11.0355V9.02246C8.28637 9.17688 6.79938 10.1173 5.90231 11.4804 5.33656 11.174 4.6886 11 4 11 1.79086 11 0 12.7909 0 15H2C2 13.8954 2.89543 13 4 13 4.41573 13 4.80183 13.1268 5.12172 13.3439ZM14 10H12V12H10V14H12V16H14V14H16V12H14V10Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 11C18.7614 11 21 8.76142 21 6 21 3.23858 18.7614 1 16 1 13.2386 1 11 3.23858 11 6 11 8.76142 13.2386 11 16 11ZM16 9C17.6569 9 19 7.65685 19 6 19 4.34315 17.6569 3 16 3 14.3431 3 13 4.34315 13 6 13 7.65685 14.3431 9 16 9ZM6 14C8.20914 14 10 12.2091 10 10 10 7.79086 8.20914 6 6 6 3.79086 6 2 7.79086 2 10 2 12.2091 3.79086 14 6 14ZM6 12C7.10457 12 8 11.1046 8 10 8 8.89543 7.10457 8 6 8 4.89543 8 4 8.89543 4 10 4 11.1046 4.89543 12 6 12Z" class="svg-bg"/>
  <path d="M9.59984 16.1994C11.0594 14.2566 13.3829 13 16 13 16.3387 13 16.6724 13.021 17 13.0619V15.083C16.6748 15.0284 16.3407 15 16 15 12.6863 15 10 17.6863 10 21H8C8 19.9233 8.21269 18.8963 8.59835 17.9588 7.89936 17.361 6.99184 17 6 17 3.79086 17 2 18.7909 2 21H0C0 17.6863 2.68629 15 6 15 7.35065 15 8.59707 15.4463 9.59984 16.1994ZM21 15H19V18H16V20H19V23H21V20H24V18H21V15Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserAddGroup is a generated icon component.
 */
let IconUserUserAddGroup = IconUserUserAddGroup_1 = class IconUserUserAddGroup extends IconBaseElement {
    render() {
        return html `${IconUserUserAddGroup_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserAddGroup.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserAddGroup = IconUserUserAddGroup_1 = __decorate([
    customElement('zui-icon-user-user-add-group')
], IconUserUserAddGroup);
export { IconUserUserAddGroup };
